<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@axios';
import { required, email } from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { ref } from '@vue/composition-api';
import useListEndereco from '@/views/cadastros/cliente//cliente/list//useListEndereco';
import { avatarText } from '@core/utils/filter';
import SLSClienteEnderecoService from '@/services/Cadastros/Cliente/SLSClienteEndereco.service';
import ModalConfirmation from '@/components/ModalConfirmation.vue';

export default {
  components: {
    ModalConfirmation,
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        clienteenderecoseq: '',
        estabelecimentoid: '',
      }),
      require: true,
    },

  },
  data() {
    return {
      dataFromApi: null,
      dataFromUfId: null,
      dataFromApiPaisId: null,
      dataFromApiCidadeId: null,
      dataFromApiTipoEndereco: null,
      deletedEndereco: null,
      isDeleteModal: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.dataClienteEndereco;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    openModalDeleteEndereco(data) {
      this.deletedEndereco = data;
      this.isDeleteModal = true;
    },
    resetFormData() {
      this.deletedEndereco = null;
      this.isDeleteModal = false;
    },
    async handleRemover(data) {
      await this.removerData(data)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Endereco deletad com sucesso',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
          this.isDeleteModal = false;
          console.log('chamei funcao refresh');
          this.refresh();
        })
        .catch((error) => {
          // Lidar com erros, se necessário
        });
    },
    async refresh() {
      console.log('funcao refresh');
      this.fetchClienteEndereco();
      console.log('termino funcao refresh');
    },
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromUf() {
      try {
        const response = await axios.get('/uf/findAll');
        this.dataFromUfId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async consultarCep() {
      const ViaCEPService = (await import('@/services/ViaCEP.service')).default;
      if (!ViaCEPService.isValidCepFormat(this.dataForm.clienteenderecocep)) return;
      try {
        const data = await ViaCEPService.buscarCep(this.dataForm.clienteenderecocep);
        if (data.logradouro) this.dataForm.clienteendereco = data.logradouro;
        if (data.bairro) this.dataForm.clienteenderecobairro = data.bairro;
        if (data.cidade) this.dataForm.clienteenderecocidade = data.cidade;
        if (data.uf && Array.isArray(this.dataFromUfId)) {
          const sigla = String(data.uf).toUpperCase();
          const match = this.dataFromUfId.find((u) => {
            const candidatos = [u.uf_sigla, u.ufsigla, u.sigla, u.uf_nome, u.ufnome, u.ufid]
              .filter(Boolean).map((v) => String(v).toUpperCase());
            return candidatos.includes(sigla);
          });
          if (match) this.dataForm.ufid = match.ufid;
        }
      } catch (err) {
        console.warn('[ViaCEP]', err && err.message ? err.message : err);
      }
    },
    async fetchDataFromPais() {
      try {
        const response = await axios.get('/pais/findAll');
        this.dataFromApiPaisId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCidade() {
      try {
        const response = await axios.get('/cidade/findAll');
        this.dataFromApiCidadeId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoEndereco() {
      try {
        const response = await axios.get('/tipoEndereco/findAll');
        this.dataFromApiTipoEndereco = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
  created() {
    this.fetchDataFromUf();
    this.fetchDataFromPais();
    this.fetchDataFromCidade();
    this.fetchDataFromTipoEndereco();
  },
  setup(props) {
    const sLSClienteEnderecoService = new SLSClienteEnderecoService();
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const formularioAtt = ref(false);
    const formularioAdd = ref(false);
    const dataClienteEndereco = ref({
      clienteid: props.value.clienteid,
      clienteenderecoseq: '',
      tipoenderecoid: '',
      clienteendereco: '',
      clienteenderecocep: '',
      clientenedereco: '',
      clienteenderecobairro: '',
      clienteenderecocidade: '',
      ufid: '',
      paisid: '',
      clienteenderecoie: '',
    });
    const formularioVisible = (status, tipo, item) => {
      if (status === 1) {
        if (tipo === 'att') {
          dataClienteEndereco.value = item;
          formularioAtt.value = true;
        } else {
          dataClienteEndereco.value.tipoenderecoid = '';
          dataClienteEndereco.value.clienteendereco = '';
          dataClienteEndereco.value.clienteenderecoseq = '';
          dataClienteEndereco.value.clienteenderecocep = '';
          dataClienteEndereco.value.clientenedereco = '',
          dataClienteEndereco.value.clienteenderecobairro = '',
          dataClienteEndereco.value.clienteenderecocidade = '',
          dataClienteEndereco.value.ufid = '',
          dataClienteEndereco.value.paisid = '',
          dataClienteEndereco.value.clienteenderecoie = '',
          formularioAdd.value = true;
        }
      } else {
        formularioAtt.value = false;
        formularioAdd.value = false;
      }
    };
    const fetchClienteEndereco = (ctx, callback) => {
      const { clienteid } = props.value;
      const queries = {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        fullObject: true,
        clienteid,
      };

      sLSClienteEnderecoService.findEnderecoCliente(queries)
        .then((response) => {
          const { data, total } = response;
          callback(data);
          perPage.value = response.perPage;
          currentPage.value = response.page;
          totalClienteEndereco.value = total;
        })
        .catch((error) => {
          // console.log(error)
          // toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: 'Error fetching users list',
          //     icon: 'AlertTriangleIcon',
          //     variant: 'danger',
          //   },
          // });
        });
    };

    const {
      perPage,
      currentPage,
      totalClienteEndereco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refClienteEnderecoListTable,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      Updated,
      create,
      removerData,
    } = useListEndereco();

    return {
      // Filter
      avatarText,
      spanderAll,
      currentTab,
      dataClienteEndereco,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalClienteEndereco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchClienteEndereco,
      formularioVisible,
      tableColumns,
      formularioAdd,
      formularioAtt,
      refClienteEnderecoListTable,
      Updated,
      create,
      removerData,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <div  v-if="formularioAtt">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          @click="formularioVisible(0)"

      >
        Voltar
      </b-button>
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Sequencia"
                label-for="clienteenderecoseq"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecoseq"
                    id="clienteenderecoseq"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Endereco"
                label-for="tipoenderecoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo Endereco"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipoenderecoid"
                    id="tipoenderecoid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cep"
                label-for="clienteenderecocep"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecocep"
                    id="clienteenderecocep"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o CEP"
                    @blur="consultarCep"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Endereco"
                label-for="clienteendereco"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Endereco"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteendereco"
                    id="clienteendereco"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Endereco"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Bairro"
                label-for="clienteenderecobairro"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Bairro"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecobairro"
                    id="clienteenderecobairro"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Bairro"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cidade"
                label-for="clienteenderecocidade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Cidade"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecocidade"
                    id="clienteenderecocidade"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Cidade"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="UF"
                label-for="ufid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="UF"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.ufid"
                    id="ufid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromUfId"
                    value-field="ufid"
                    text-field="uf_nome"
                    placeholder="Selecione um uf"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Pais"
                label-for="paisid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Pais"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.paisid"
                    id="paisid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiPaisId"
                    value-field="paisid"
                    text-field="pais_nome"
                    placeholder="Pais"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Inscr. Estadual"
                label-for="clienteenderecoie"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Inscr. Estadual"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecoie"
                    id="clienteenderecoie"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Inscr. Estadual"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Observações"
                label-for="clienteenderecoobservacoes"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Observações"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.clienteenderecoobservacoes"
                    id="clienteenderecoobservacoes"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Observações"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          @click="Updated(dataForm)"
      >
        Salvar Alterações
      </b-button>
    </div>
    <div  v-else-if="formularioAdd">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          @click="formularioVisible(0)"
      >
        Voltar
      </b-button>
      {{ dataForm }}
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Seq."
                label-for="clienteenderecoseq"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecoseq"
                    id="clienteenderecoseq"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Endereco"
                label-for="tipoenderecoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipoenderecoid"
                    id="tipoenderecoid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiTipoEndereco"
                    value-field="tipoenderecoid"
                    text-field="tipoenderecodescricao"
                    placeholder="Tipo Endereco"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cep"
                label-for="clienteenderecocep"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecocep"
                    id="clienteenderecocep"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Cep"
                    @blur="consultarCep"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Endereco"
                label-for="clienteendereco"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Endereco"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientenedereco"
                    id="clientenedereco"
                    :state="errors.length > 0 ? false : null"

                    placeholder="Endereco"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Bairro"
                label-for="clienteenderecobairro"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Bairro"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecobairro"
                    id="clienteenderecobairro"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Bairro"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cidade"
                label-for="clienteenderecocidade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Cidade"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecocidade"
                    id="clienteenderecocidade"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Cidade"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="UF"
                label-for="ufid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="UF"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.ufid"
                    id="ufid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromUfId"
                    value-field="ufid"
                    text-field="uf_nome"
                    placeholder="Selecione um uf"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Pais"
                label-for="paisid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Pais"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.paisid"
                    id="paisid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiPaisId"
                    value-field="paisid"
                    text-field="pais_nome"
                    placeholder="Pais"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Inscrição Estadual"
                label-for="clienteenderecoie"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Inscr. Estadual"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteenderecoie"
                    id="clienteenderecoie"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Inscrição Estadual"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Observações"
                label-for="clienteenderecoobservacoes"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Observações"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.clienteenderecoobservacoes"
                    id="clienteenderecoobservacoes"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Observações"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          @click="create(dataForm)"
      >
        Salvar Alterações
      </b-button>
    </div>
    <div  v-else>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Pesquisar..."
              />
              <b-button
                  variant="primary"
                  @click="formularioVisible(1,'add')"
              >
                <div class="d-flex" style="gap: 5px">
                  <iconfy icon="mdi:plus"/>
                  <span class="">Criar</span>
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
          ref="refClienteEnderecoListTable"
          class="position-relative"
          :items="fetchClienteEndereco"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="Nenhum registro encontrado"
      >
        <template #cell(actions)="data">
          <div>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-primary"
                class="btn-icon mr-1"
                @click="formularioVisible(1, 'att',data.item)"
            >
              <feather-icon icon="EyeIcon"/>
            </b-button>

            <b-button
                variant="gradient-danger"
                class="btn-icon"
                @click="openModalDeleteEndereco(data.item)"
            >
              <feather-icon icon="TrashIcon"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
                      <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                          dataMeta.of
                        }} entries</span>
          </b-col>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="totalClienteEndereco"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </div>
    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-endereco"
        title="Deletar Endereco"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedEndereco)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Endereço?</p>
        </div>
      </template>
    </modal-confirmation>

  </validation-observer>

</template>
